import CreatePostureTemplateButton from './CreatePostureTemplateButton'

export default CreatePostureTemplateButton
